<template>
  <section>
    <div class="german">
      <h1>Teilnahmebedingungen</h1>
      <p>
        Liebe Teilnehmerin und lieber Teilnehmer, <br />
        Sie interessieren sich dafür, eine web-basierte Beratung in Anspruch zu nehmen. Im Folgenden
        informieren wir Sie über die Teilnahmebedingungen dieses kostenlosen Onlineangebots.
      </p>
      <p>
        <strong>Unser Beratungsangebot</strong>
      </p>
      <p>
        Sie wenden sich an uns, weil Sie ein Anliegen in Ihrem Leben haben, wofür Sie eine Beratung
        möchten. Dieses Anliegen kann unterschiedlicher Art sein: manche Personen stehen vor einer
        wichtigen Entscheidung im Leben, andere wünschen sich mehr Effektivität oder Erfolg im Job
        oder Studium und für viele Menschen sind die Beziehungen zu ihren Mitmenschen wichtig aber
        nicht immer konfliktfrei. Unser lösungsorientiertes Beratungsangebot kann Sie dabei
        unterstützen, herauszufinden, was genau Ihr Anliegen ist und welche Schritte Sie unternehmen
        könnten, um ihrem Ziel näher zu kommen. Der erste Schritt im Anschluss an die Registrierung
        und Ihr Einverständnis zur Teilnahme ist, zu schauen, ob das Beratungsangebot für Sie
        passend ist. Dies geschieht durch ein umfangreiches Assessment (mittels ausgewählter
        Fragebögen) ihrer körperlichen und psychischen Konstitution. Da Ilajnafsy auch Therapien
        anbietet, ist es notwendig, in diesem Assessment abgrenzen zu können, ob für Sie die
        Beratung oder ggfs. doch ein Therapieangebot in Frage kommt. Daher werden Sie ggfs. im
        Anschluss an das Fragebogenassessment dazu eingeladen, ein Interview zu buchen. Im Interview
        wird Ihre psychische Gesundheit und Ihre allgemeine Lebensqualität nochmal genauer erfragt,
        um sicher zu stellen, ob das Programm tatsächlich Ihren gewünschten Veränderungsprozess bzw.
        die Bearbeitung Ihres Anliegens unterstützen kann. Die Teilnahme an allen unseren Programmen
        ist freiwillig und kostenfrei.
      </p>
      <p>
        <strong>Ablauf und Rahmen der Onlineberatung</strong>
      </p>
      <p>
        Die Onlineberatung ist eine Kurzzeitintervention, welche ca. 4 Wochen dauert. Die Zuteilung
        zur Beratung erfolgt im Anschluss an ein ca. 1-stündiges Fragebogenassessment und ein ca.
        1-stündiges Audio-Gespräch mit einem unserer Mitarbeiter oder einer unserer
        Mitarbeiterinnen. Das Assessment enthält verschiedene Fragen zu Ihrem psychischen
        Wohlbefinden, einschließlich traumatischer Ereignisse, die Sie möglicherweise erlebt haben,
        sowie zu suizidalen Gedanken oder Absichten. Die Kommunikation zwischen Ihnen und Ihrem
        persönlichen Onlineberater (E-coach) findet dabei in schriftlicher Form über unser
        geschütztes Onlineportal statt. Die Beratungsmodule sind nach einem wissenschaftlich
        überprüften Ablauf aufgebaut. Dieser besteht aus festgelegten Schreibaufgaben. Der Ablauf
        wird jedoch an die persönliche Situation und das Anliegen des Klienten oder der Klientin
        angepasst. Im Rahmen der Beratung werden Sie wöchentlich im schriftlichen Kontakt (über
        sogenannte „Beratungsbriefe“) mit Ihrem Onlineberater bzw. ihrer Onlineberaterin stehen. Das
        Verfassen der Briefe basiert auf speziellen Anweisungen, welche Ihnen Ihr Onlineberater oder
        ihre Onlineberaterin vorher zukommen lässt. Diese verpflichten sich, Ihnen nach Ablauf von
        ca. zwei Werktagen auf Ihre Briefe zu antworten. Sollten Sie ohne weitere Absprache mit
        Ihrem Berater / Ihrer Beraterin Ihre Schreibaufgaben 14 Tage nicht erledigen, scheiden Sie
        automatisch aus dem Programm aus.
      </p>
      <p>
        <strong>Ein- und Ausschlusskriterien</strong>
      </p>
      <p>
        Anhand von Fragebögen und einem Gespräch wird untersucht, ob das Onlineberatungs-angebot
        derzeit eine geeignete Möglichkeit für Sie darstellt, Ihr Anliegen zu bearbeiten. Ein
        Mindestalter von 18 Jahren ist Voraussetzung für die Teilnahme. Die Teilnahme am
        Beratungsangebot ist nicht möglich, wenn eine intensivere, medizinische bzw. psychologische
        Unterstützung benötigt wird. Gegebenenfalls bieten wir Ihnen – bei entsprechender
        Symptomatik - im Anschluss an das Fragebogenassessment an, statt der Beratung eine unserer
        Therapien in Anspruch zu nehmen. Sollten Sie zeitgleich eine psychotherapeutische oder
        psychiatrische Behandlung in Anspruch nehmen, bitten wir darum, uns dies mitzuteilen. Zudem
        sollten für die gesamte Behandlungsdauer eine gültige, persönliche E-Mail-Adresse und eine
        ausreichende Internetverbindung verfügbar sein.
      </p>
      <p>
        <strong>Wissenschaftliche Studie und Freiwilligkeit der Teilnahme</strong>
      </p>
      <p>
        Die Teilnahme an unserem Onlineberatungsangebot ist freiwillig und kostenfrei. Wir möchten
        Sie darauf hinweisen, dass wir die Daten der (der Beratung angegliederten)
        Fragebogen-assessments unter Umständen statistisch auswerten und anonymisiert
        veröffentlichen. Die Auswertung der Daten dient dem Zweck zu prüfen, wie gut das Angebot
        angenommen wird und wie viele Personen davon profitieren. Wir erheben zum Beispiel die
        allgemeine Lebensqualität, die psychische Gesundheit und die Motivation für Veränderung.
        Ebenfalls möchten wir ein genaueres Bild über die Auswirkungen von belastenden
        Lebenserfahrungen bei arabischsprachigen Teilnehmern erhalten, um das Beratungsangebot ggfs.
        besser darauf abstimmen zu können. Wenn Sie auf die Teilnahme an dieser Studie verzichten
        möchten, haben Sie keine Nachteile zu erwarten. Dies gilt auch, wenn Sie Ihre dazu gegebene
        Einwilligung zu einem späteren Zeitpunkt widerrufen. Sie können die Beratung zudem jederzeit
        ohne Angabe von Gründen abbrechen, die bis dahin erhobenen Daten werden anonym
        weiterverwendet. Eine Löschung dieser kann beantragt werden. Hierzu schicken Sie uns bitte
        eine Mail an support-ilajnafsy@ueberleben.org.
      </p>
      <p>
        <strong>Vertraulichkeit der Daten</strong>
      </p>
      <p>
        Im Rahmen dieser Studie werden persönliche Daten von Ihnen erfasst, welche jedoch nur
        Fachleuten zur wissenschaftlichen Auswertung zugänglich sind. Allerdings wird auch hierbei
        die Vertraulichkeit strikt gewahrt und Ihr Name wird in keiner Weise in Publikationen oder
        Berichten, die aus der Studie hervorgehen, veröffentlicht. Alle an der Beratung beteiligten
        Personen unterliegen zudem der Schweigepflicht. Dies bedeutet, dass alle ausgetauschten
        Informationen streng vertraulich behandelt werden. Die Antworten der Fragebögen werden nicht
        anhand von Namen, sondern lediglich anhand von Nummern gespeichert, so dass die Herkunft
        nicht nachvollziehbar ist.
      </p>
      <p>
        <strong>Unfreiwilliger Ausschluss</strong>
      </p>
      <div>
        Die Teilnahme kann durch den Onlineberaterin bzw. die Onlineberaterin abgebrochen werden.
        Die Beratung wird vorzeitig beendet, wenn:
        <ul>
          <li>sich herausstellt, dass Ein- und Ausschlusskriterien verletzt wurden</li>
          <li>
            eine akute Krise auftritt (z.B. akute Suizidalität) und eine intensivere Behandlung
            angemessen scheint
          </li>
          <li>
            wenn sich die Teilnehmer oder Teilnehmerinnen mehrfach nicht an die durch den
            Onlineberater bzw. die Onlineberaterin kommunizierten Vereinbarungen halten
          </li>
          <li>Sie 14 Tage nicht geantwortet haben.</li>
        </ul>
      </div>
      <p>
        Informationen zu den Therapieangeboten von Ilajnafsy finden Sie
        <a :href="url" target="_blank" rel="noopener noreferrer">hier</a>
      </p>
    </div>
    <div class="arabic">
      <h1>شروط المشاركة</h1>
      <p>
        عزيزي المُشارك، عزيزتي المُشارِكة،<br />
        أنت مهتم بتلقي الإرشاد النفسي عبر الإنترنت. سنخبرك أدناه بشروط المشاركة في هذا العرض المجاني
        عبر الإنترنت.
      </p>
      <p>
        <strong>عرض الإرشاد النفسي</strong>
      </p>
      <p>
        تتوجه إلينا لأن لديك مشكلة في حياتك وتريد الإرشاد النفسي بشأنها. يمكن أن تكون هذه المشكلة
        على شكل أنواع مختلفة: يواجه بعض الأشخاص قراراً مهماً في الحياة، والبعض الآخر يريد المزيد من
        الفعالية أو النجاح في عملهم أو دراستهم، وبالنسبة للعديد من الأشخاص، تعتبر العلاقات مع
        الآخرين مهمة ولكنها ليست دائماً خالية من الخلافات. يمكن أن يساعدك برنامجنا للإرشاد النفسي
        القائم على حل المشكلات في معرفة ما يقلقك بالضبط وما هي الخطوات التي يمكنك اتخاذها للاقتراب
        من هدفك. الخطوة الأولى بعد التسجيل والموافقة على المشاركة هي معرفة ما إذا كان برنامج الإرشاد
        النفسي مناسب لك. ويتم ذلك من خلال تقييم شامل (باستخدام استبيانات مختارة) لحالتك الجسدية
        والنفسية. وبما أن برنامج „علاج نفسي“ يقدم أيضاً علاجات نفسية أخرى، فمن الضروري أن يتم من
        خلال هذه الإستبيانات تحديد ما إذا كان عرض الإرشاد النفسي أو عرض العلاج النفسي، إذا لزم
        الأمر، خياراً مناسباً لك. لذلك، قد تتم دعوتك لحجز مقابلة بعد استبيانات التقييم. خلال
        المقابلة، سيتم سؤالك عن صحتك النفسية وجودة حياتك العامة بمزيد من التفصيل للتأكد من ما إذا
        كان البرنامج يمكنه بالفعل دعم عملية التغيير المرغوبة أو معالجة مشكلتك. المشاركة في جميع
        برامجنا اختيارية ومجانية.
      </p>
      <p>
        <strong>مسار وإطار الإرشاد النفسي عبر الإنترنت</strong>
      </p>
      <p>
        الإرشاد النفسي عبر الإنترنت هو تدخل قصير المدى يستمر حوالي 4 أسابيع. . تتضمن هذه الاستبيانات
        أسئلة متنوعة حول صحتك النفسية، من ضمنها أسئلة حول الحدث أو الأحداث الصادمة التي قد تكون
        تعرضت لها ، بالإضافة الى أسئلة عن الأفكار أو النوايا الانتحارية . يتم التحويل للإرشاد النفسي
        بعد استبيان التقييم والذي مدته ساعة تقريباً وبعد محادثة صوتية لمدة ساعة تقريباً أيضاً مع أحد
        المختصين أو المختصات. يتم التواصل بينك وبين مرشدك النفسي الشخصي عبر الإنترنت (المدرب
        الإلكتروني) بشكل كتابي عبر بوابتنا الإلكترونية المحمية. تم تصميم الرسائل الإرشادية وفقاً
        لعملية تم التحقق منها علمياً. تتكون هذه العملية من مجموعة مهام كتابية. يتم تكييف العملية على
        حسب الوضع الشخصي واهتمامات المسترشد أو المسترشدة. في إطار الإرشاد النفسي ستكون في تواصل
        كتابي أسبوعي (عبر ما يسمى بـ "رسائل الإرشاد النفسي") مع مرشدك/مرشدتك النفسيين عبر الإنترنت.
        تعتمد كتابة الرسائل على تعليمات خاصة سيقدمها لك مرشدك/مرشدتك النفسيين عبر الإنترنت مسبقاً.
        ويتعهدون بالرد على رسائلك بعد يومي عمل تقريباً. إذا لم تكمل مهامك الكتابية خلال 14 يوماً دون
        إعلام مرشدك/مرشدتك النفسيين، فسيتم إقصائك أوتوماتيكياً من البرنامج.
      </p>
      <p>
        <strong>معايير القبول والإقصاء</strong>
      </p>
      <p>
        من خلال استخدام الاستبيانات والمقابلة التشخيصية يتم فحص ما إذا كانت خدمة الإرشاد النفسي عبر
        الإنترنت خياراً مناسباً لك لمعالجة مشكلتك. يشترط أن يكون الحد الأدنى للعمر 18 عاماً
        للمشاركة. لا يمكن المشاركة في خدمة الإرشاد النفسي إذا كانت هناك حاجة إلى دعم طبي أو نفسي
        مكثف. عند اللزوم إذا كانت لديك أعراض معينة بعد ملء استبيانات التقييم، فسنقدم لك خيار
        الاستفادة من أحد علاجاتنا بدلاً من الإرشاد النفسي. إذا كنت تتلقى علاجاً نفسياً أو تزور
        طبيباً نفسياً في نفس الوقت، فيرجى إخبارنا بذلك. بالإضافة إلى ذلك، يجب أن يتوفرلديك عنوان
        بريد إلكتروني شخصي صالح وتوفر الاتصال بالإنترنت طوال مدة العلاج.
      </p>
      <p>
        <strong>الدراسة العلمية والمشاركة الطوعية</strong>
      </p>
      <p>
        المشاركة في الإرشاد النفسي عبر الإنترنت لدينا طوعية ومجانية. نود أن نشير إلى أننا قد نقوم
        بتقييم البيانات (للمشاركين في الإرشاد النفسي) من استبيانات التقييم إحصائياً ونشرها بشكل
        مجهول. الغرض من تقييم البيانات هو التحقق من مدى جودة العرض وعدد الأشخاص الذين يستفيدون منه.
        على سبيل المثال، نقوم بتقييم الجودة العامة للحياة والصحة النفسية والدافع للتغيير. نود أيضاً
        الحصول على صورة أكثر دقة لتأثيرات تجارب الحياة الضاغطة على المشاركين الناطقين باللغة العربية
        حتى نتمكن من مواءمة وتعديل الإرشاد النفسي الذي نقدمه بشكل أفضل إذا لزم الأمر. إذا قررت عدم
        المشاركة في هذه الدراسة، فلن تواجه أي سلبيات. وينطبق هذا أيضاً إذا قمت بإلغاء موافقتك في وقت
        لاحق. يمكنك أيضاً إلغاء الإرشاد النفسي في أي وقت دون إبداء الأسباب؛ وسيستمر استخدام البيانات
        التي تم جمعها حتى ذلك الحين بشكل مجهول. يمكن طلب حذف هذه البيانات في أي وقت . للقيام بذلك،
        يرجى إرسال بريد إلكتروني إلينا على support-ilajnafsy@ueberleben.org.
      </p>
      <p>
        <strong>سرية البيانات</strong>
      </p>
      <p>
        في إطار هذه الدراسة، سيتم جمع البيانات الشخصية منك، ولكن لن تكون متاحة إلا للمختصين في
        التحليل العلمي. ومع ذلك، سيتم أيضاً الحفاظ على السرية بشكل صارم ولن يتم نشر اسمك بأي شكل من
        الأشكال في المنشورات أو التقارير الناتجة عن الدراسة. جميع الأشخاص المختصين المشاركين في
        الإرشاد النفسي ملزمون أيضاً في الحفاظ على السرية التامة. وهذا يعني أن جميع المعلومات
        المتبادلة يتم التعامل معها بسرية تامة. لا يتم تخزين إجابات الاستبيانات بناءً على الأسماء، بل
        بناءً على الأرقام فقط، بحيث لا يمكن تتبع المصدر.
      </p>
      <p>
        <strong>الإقصاء غير الطوعي</strong>
      </p>
      <div>
        يمكن إلغاء المشاركة من قبل المرشد النفسي عبر الإنترنت. سينتهي الإرشاد النفسي مبكراً إذا:
        <ul>
          <li>تبين أن معايير القبول والاستبعاد قد انتهكت</li>
          <li>حدوث أزمة حادة (مثل خطورة الانتحار) وتبين أن العلاج المكثف أكثر ملاءمة</li>
          <li>
            إذا لم يلتزم المشاركون بشكل متكرر بالاتفاقيات التي أبلغها المرشد/المرشدة النفسيين عبر
            الإنترنت
          </li>
          <li>لم تقم بالرد لمدة 14 يوماً.</li>
        </ul>
      </div>
      <p>
        يمكن العثور على معلومات حول عروض العلاج في برنامج „علاج نفسي“<a
          :href="url"
          target="_blank"
          rel="noopener noreferrer"
          >هنا</a
        >
      </p>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  computed: {
    url() {
      return this.$router.resolve({ name: 'conditionsTherapy' }).href
    },
  },
})
</script>

<style></style>
